import { user } from '@/store/reducerUser';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import { useSelector } from 'react-redux';
import { Iconify } from 'src/components/iconify';

export function CheckoutButton() {
  const userState = useSelector(user);
  const totalItems = userState?.basket?.items?.total || 0;

  const handleRedirect = () => {
    window.location.href = `${process.env.REACT_APP_PRODUCT_WEBAPP_URI || ''}/app/dashboard/products/checkout`;
  };

  return (
    <Link onClick={handleRedirect} style={{ textDecoration: 'none' }}>
      <IconButton aria-label="Checkout button">
        {totalItems > 0 ? (
          <Badge badgeContent={totalItems} color="error">
            <Iconify width={24} icon="solar:cart-3-bold" />
          </Badge>
        ) : (
          <Iconify width={24} icon="solar:cart-3-bold" />
        )}
      </IconButton>
    </Link>
  );
}
